import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import StoreConnectedApp from './StoreConnectedApp'

// Reference Example: https://github.com/alocke12992/migrating-to-single-spa-react/tree/master
export const { bootstrap, mount, unmount } = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: StoreConnectedApp,
  domElementGetter: () => {
    return document.getElementById('root')
  },
})



// WEBPACK FOOTER //
// ./src/root.app.js